import { render, staticRenderFns } from "./d-book-write-user-review-button.vue?vue&type=template&id=69bdaf5c&"
import script from "./d-book-write-user-review-button.vue?vue&type=script&lang=js&"
export * from "./d-book-write-user-review-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports